import './AppStatusMessage.scss';

import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ExportOutlined } from '@ant-design/icons';
import React from 'react';

const FROM = '*From';

export interface AppStatusMessageProps {
	link?: string;
	message?: string;
}

export const AppStatusMessage: React.FC<AppStatusMessageProps> = ({ link, message }) => {
	if (!message) {
		return null;
	}

	return (
		<div className='app-status-message'>
			<div className='status-message-title'>
				<div className='h3'>{ COPY_SPECIFIC.APPLICATION_STATUS }</div>
				<a
					href={ link }
					target='_blank'>
					<ExportOutlined />
				</a>
			</div>
			{ message }
			<div className='status-message-attribution'>
				{ FROM }
				<a
					href={ link }
					target='_blank'>
					{ link }
				</a>
			</div>
		</div>
	);
};
